import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ServicesService } from 'src/app/core/services/services.service';
import { CountryForMap } from 'src/app/core/utils/type';

@Component({
  selector: 'app-waiting-tutorial-modal',
  templateUrl: './waiting-tutorial-modal.component.html',
  styleUrls: ['./waiting-tutorial-modal.component.scss'],
})
export class WaitingTutorialModalComponent implements OnInit {
  waitingDescription = '';
  content_1 = '';
  content_2 = '';
  content_3 = '';
  slides: { title: string; description: string; mainImage: string; icon: string }[] = [];
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 1000,
    items: 1,
    autoWidth: true,
    margin: 10,
    autoplay: true,
    center: true,
    nav: false,
    animateOut: 'fadeOut',
    responsive: {
      0: {
        items: 1,
      },
      300: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };
  greeting = '';
  kimboText = 'KimboCare';
  getStartedButtonLabel = '';
  bpReached = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {},
    public dialogRef: MatDialogRef<WaitingTutorialModalComponent>,
    private translateService: TranslateService,
    private services: ServicesService,
    private breakpointObserver: BreakpointObserver,
  ) {
    breakpointObserver.observe('(min-width: 640px)').subscribe((state) => {
      if (state.matches) {
        this.bpReached = true;
      } else {
        this.bpReached = false;
      }
    });
    this.greeting = this.translateService.currentLang === 'en' ? 'Welcome to' : 'Bienvenue à';
    this.getStartedButtonLabel =
      this.translateService.currentLang === 'en' ? 'Get started' : 'Commencer';

    this.slides = [
      {
        title:
          this.translateService.currentLang === 'en'
            ? 'Family connection is essential'
            : "La famille, c'est primordial",
        description:
          this.translateService.currentLang === 'en'
            ? 'You’d do everything for your loved ones.'
            : 'Vous feriez tout pour vos proches.',
        mainImage: 'assets/images/step-1.png',
        icon: 'assets/images/icon-step-1.svg',
      },
      {
        title:
          this.translateService.currentLang === 'en'
            ? 'When the unexpected occurs'
            : "En cas d'imprévu",
        description:
          this.translateService.currentLang === 'en'
            ? "Sending money doesn't guarantee they'll receive the right care.."
            : "Envoyer de l'argent ne garantit pas qu'ils reçoivent les bons soins.",
        mainImage: 'assets/images/step-2.png',
        icon: 'assets/images/icon-step-2.svg',
      },
      {
        title:
          this.translateService.currentLang === 'en' ? 'Through KimboCare' : 'Grâce à KimboCare',
        description:
          this.translateService.currentLang === 'en'
            ? 'You send health credits so they can access quality care.'
            : "Vous envoyez des crédits de santé afin qu'ils accèdent à des soins de qualité.",
        mainImage: 'assets/images/step-3.png',
        icon: 'assets/images/icon-step-3.svg',
      },
      {
        title:
          this.translateService.currentLang === 'en'
            ? 'Stay more connected than ever '
            : 'Restez connectés à distance',
        description:
          this.translateService.currentLang === 'en'
            ? 'Follow the care and recovery of your loved ones online.'
            : 'En suivant en ligne les soins et le rétablissement de vos proches.',
        mainImage: 'assets/images/step-4.png',
        icon: 'assets/images/icon-step-4.svg',
      },
    ];

    this.waitingDescription =
      this.translateService.currentLang === 'en'
        ? '<strong>KimboCare</strong> allows you to buy quality care (health credits) for your loved ones while keeping your expenses perfectly under control. No need for money transfers.'
        : "<strong>KimboCare</strong> vous permet d'acheter des soins de qualité (crédits de santé) pour vos proches tout en maîtrisant parfaitement vos dépenses. Plus besoin de transfert d'argent.";
  }

  ngOnInit(): void {}

  closeDialog(): void {
    this.dialogRef.close();
    this.services.sessionService.storeGlobalTutorialState();
  }
}
